// actions
export const SHOW_CONFIRM_DIALOG = 'SHOW_CONFIRM_DIALOG'
export const OK_CONFIRM_DIALOG = 'OK_CONFIRM_DIALOG'
export const CANCEL_CONFIRM_DIALOG = 'CANCEL_CONFIRM_DIALOG'
// mutations
export const UPDATE_CONFIRM_DIALOG = 'UPDATE_CONFIRM_DIALOG'
